module.exports = __webpack_public_path__ + "4b8f3c5716de94d3fc6ec99dc2aa99d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/adventure-tube-blue.png
// module id = 1222
// module chunks = 0